import bike1 from "./full/IMG_0159.webp";
import bike2 from "./full/IMG_0172.webp";
import bike3 from "./full/IMG_0186.webp";
import bike4 from "./full/IMG_0236.webp";
import bike5 from "./full/IMG_0249.webp";
import bike6 from "./full/IMG_0248.webp";
import bike7 from "./full/20240811_091547.webp";
import bike8 from "./full/20240811_091537.webp";
import bike9 from "./full/rowery.webp";
import bike10 from "./full/IMG_0177.webp";
import bike11 from "./full/IMG_0232.webp";
import bike12 from "./full/IMG_0252.webp";
import bike1Thumb from "./thumb/IMG_0159.webp";
import bike2Thumb from "./thumb/IMG_0172.webp";
import bike3Thumb from "./thumb/IMG_0186.webp";
import bike4Thumb from "./thumb/IMG_0236.webp";
import bike5Thumb from "./thumb/IMG_0249.webp";
import bike6Thumb from "./thumb/IMG_0248.webp";
import bike7Thumb from "./thumb/20240811_091547.webp";
import bike8Thumb from "./thumb/20240811_091537.webp";
import bike9Thumb from "./thumb/rowery.webp";
import bike10Thumb from "./thumb/IMG_0177.webp";
import bike11Thumb from "./thumb/IMG_0232.webp";
import bike12Thumb from "./thumb/IMG_0252.webp";

export const bikesImages = [
    { thumb: bike1Thumb, full: bike1, altKey: "1" },
    { thumb: bike2Thumb, full: bike2, altKey: "2" },
    { thumb: bike3Thumb, full: bike3, altKey: "3" },
    { thumb: bike4Thumb, full: bike4, altKey: "4" },
    { thumb: bike5Thumb, full: bike5, altKey: "5" },
    { thumb: bike6Thumb, full: bike6, altKey: "6" },
    { thumb: bike7Thumb, full: bike7, altKey: "7" },
    { thumb: bike8Thumb, full: bike8, altKey: "8" },
    { thumb: bike9Thumb, full: bike9, altKey: "9" },
    { thumb: bike10Thumb, full: bike10, altKey: "10" },
    { thumb: bike11Thumb, full: bike11, altKey: "11" },
    { thumb: bike12Thumb, full: bike12, altKey: "12" }
]; 